export default __webpack_public_path__ + "static/media/09.11818036.jpg";